import { formatSortingForApi } from 'helpers/sortingFormatter';
import { searchActions } from 'modules/app/redux/creators';
import { IMPORTED_ORGANIZATION_FILTER_KEY } from 'modules/importedOrganizations/constants';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { filterActions, importedOrganizationActions, pageInfoActions, sortingActions } from '../actions/creators';
import {
  makeGetImportedOrganizationFilters,
  makeGetImportedOrganizationPageInfo,
  makeGetImportedOrganizationSorting,
} from '../selectors/importedOrganization';
import importedOrganizationApi from '../../api/importedOrganizationApi';
import { ImportedOrganization } from '../../types/importedOrganization';

function* importedOrganizationSaga() {
  yield takeLatest(
    [
      importedOrganizationActions.getImportedOrganizations,
      pageInfoActions.setPageSize,
      pageInfoActions.setPage,
      sortingActions.setSorting,
      filterActions.setStatusFilter,
    ],
    handleGetFilteredOrganizations
  );
  yield takeLatest(
    [pageInfoActions.setPageSize, filterActions.setStatusFilter],
    handleGetFilteredOrganizationsWithPage1
  );
  yield takeLatest(searchActions.setSearch, handleSearchChange);
  yield takeLatest(importedOrganizationActions.approveImportedOrganization, handleApproveImportedOrganization);
  yield takeLatest(importedOrganizationActions.rejectImportedOrganization, handleRejectImportedOrganization);
}

function* handleGetFilteredOrganizationsWithPage1() {
  yield put(pageInfoActions.setPage(1));
}

function* handleGetFilteredOrganizations() {
  yield put(importedOrganizationActions.getImportedOrganizationsRequest.request());
  const filters = yield select(makeGetImportedOrganizationFilters());
  const pageInfo = yield select(makeGetImportedOrganizationPageInfo());
  const sorting = yield select(makeGetImportedOrganizationSorting());
  try {
    const payload = yield call(
      importedOrganizationApi.getImportedOrganizations,
      pageInfo,
      filters,
      formatSortingForApi(sorting)
    );
    yield put(importedOrganizationActions.getImportedOrganizationsRequest.success(payload));
  } catch (e) {
    yield put(importedOrganizationActions.getImportedOrganizationsRequest.failure(e.response));
  }
}

function* handleSearchChange(action: ReturnType<typeof searchActions.setSearch>) {
  if (action.payload.filterKey === IMPORTED_ORGANIZATION_FILTER_KEY) {
    yield put(pageInfoActions.setPage(1));
  }
}

function* handleApproveImportedOrganization(
  action: ReturnType<typeof importedOrganizationActions.approveImportedOrganization>
) {
  yield put(importedOrganizationActions.approveImportedOrganizationRequest.request());
  try {
    const payload: ImportedOrganization = yield call(
      importedOrganizationApi.approveImportedOrganization,
      action.payload
    );
    const { hasNextPage } = yield select(makeGetImportedOrganizationPageInfo());
    yield put(importedOrganizationActions.approveImportedOrganizationRequest.success(hasNextPage ? null : payload));
    action.successCallback?.();
  } catch (e) {
    yield put(importedOrganizationActions.approveImportedOrganizationRequest.failure(e.response));
  }
}
function* handleRejectImportedOrganization(
  action: ReturnType<typeof importedOrganizationActions.rejectImportedOrganization>
) {
  yield put(importedOrganizationActions.rejectImportedOrganizationRequest.request());
  try {
    const payload: ImportedOrganization = yield call(
      importedOrganizationApi.rejectImportedOrganization,
      action.payload
    );
    const { hasNextPage } = yield select(makeGetImportedOrganizationPageInfo());
    yield put(importedOrganizationActions.rejectImportedOrganizationRequest.success(hasNextPage ? null : payload));
    action.successCallback?.();
  } catch (e) {
    yield put(importedOrganizationActions.rejectImportedOrganizationRequest.failure(e.response));
  }
}

export default importedOrganizationSaga;
